import React, {SVGProps} from 'react';
import styles from './NavButton.module.scss'
import { ReactComponent as ChevronIcon } from '../../../../assets/images/global-icons/chevron_ic.svg'
import {Flex} from "antd";

interface NavButtonInterface {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>,
  title: string,
  description?: string,
  status?: string,
  onClick?: () => void,
  isActive?: boolean
}

const NavButton = ({Icon, title, description, status, onClick, isActive}: NavButtonInterface) => {
  return (
    <Flex justify={"space-between"} align={"center"} onClick={onClick} className={`${styles.NavButton} ${isActive ? styles['NavButton--active'] : ''}`}>
      <Flex align={"center"} gap={'12px'}>
        <Icon className={styles.NavButton__icon} width={26} height={26}/>
        <Flex vertical className={styles.NavButton__content}>
          <span>{title} {status && (
            <span className={status === 'approved'
              ? styles.NavButton__content__approved
              : status === 'pending' ? styles.NavButton__content__notApproved : styles.NavButton__content__reject}>
              {status === 'approved' ? 'Approved' : status === 'pending' ? 'Pending...' : 'Rejected'}
            </span>
          )}
          </span>
          {description && <p>{description}</p>}
        </Flex>
      </Flex>
      <ChevronIcon className={styles.NavButton__icon} />
    </Flex>
  );
};

export default NavButton;